import React from 'react';
import cn from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { styleFromWidthHeight, getDeviationType } from '../../_helpers';
import LiteratureCoverLetter from '../../../LiteratureCoverLetter';
import { DeviationTypes } from '../../../types/deviation';
import s from './MiniText.scss';
// This is not a DS card, just a small placeholder for places that
// are too tiny to show text anyway, ie. the user avatar tooltip
// It's based on antfart-sized lit dumbo
export var MiniText = function (_a) {
    var className = _a.className, width = _a.width, height = _a.height, responsive = _a.responsive, deviation = _a.deviation, title = _a.deviation.title, ariaHidden = _a["aria-hidden"];
    var deviationType = getDeviationType(deviation);
    return (React.createElement(Section, { className: cn(s['root'], className), style: styleFromWidthHeight({ width: width, height: height }, responsive), "aria-hidden": ariaHidden },
        deviationType === DeviationTypes.LITERATURE && (React.createElement(LiteratureCoverLetter, { title: title, isBigEnough: false })),
        React.createElement(Heading, { className: s['title'] }, title)));
};
MiniText.displayName = 'MiniText';
export default MiniText;
//# sourceMappingURL=MiniText.js.map